import { arrayOf, bool, func, string } from 'prop-types';
import React from 'react';
import {
  Button,
  Col,
  FormGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';

import { pcDelayedStartReasonsOptions } from '../campaigns/constants';
import MultiSelect from '../generic/MultiSelect';
import { getTooltipLabelWithText } from '../generic/Tooltip';
import { isAdOps } from '../layout/Variant/Variant';
import HELP_TEXTS from './utils/help-texts';

const MandatoryDelayReason = ({
  isDelayReasonVisible,
  changeDelayReasonVisibility,
  pcDelayedStartReasons,
  onChange,
}) => {
  const inputProps = {
    onChange,
    readOnly: !onChange,
    disabled: !onChange,
  };

  const TooltipLabel = getTooltipLabelWithText(HELP_TEXTS);

  return (
    <Modal
      isOpen={isDelayReasonVisible}
      toggle={() => changeDelayReasonVisibility(!isDelayReasonVisible)}
      size="md"
    >
      <>
        <ModalHeader>Please provide delay reason</ModalHeader>
        <ModalBody>
          <FormGroup row className="mb-0">
            <TooltipLabel
              helpKey="pcDelayedStartReasons"
              text="Briefing Delay Reasons"
              colWidth={4}
              section="header"
              resource="ca"
            />
            <Col sm={8}>
              <MultiSelect
                options={pcDelayedStartReasonsOptions}
                id="ca-pcDelayedStartReasons"
                name="pcDelayedStartReasons"
                value={pcDelayedStartReasons}
                {...inputProps}
                readOnly={isAdOps()}
              />
            </Col>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={() => changeDelayReasonVisibility(false)}
            color="primary"
          >
            Save
          </Button>
        </ModalFooter>
      </>
    </Modal>
  );
};

MandatoryDelayReason.propTypes = {
  pcDelayedStartReasons: arrayOf(string).isRequired,
  onChange: func,
  isDelayReasonVisible: bool,
  changeDelayReasonVisibility: func,
};

MandatoryDelayReason.defaultProps = {
  isDelayReasonVisible: false,
  changeDelayReasonVisibility: undefined,
  onChange: () => {},
};

export default MandatoryDelayReason;
